import React from 'react';
import Grid2 from '@mui/material/Unstable_Grid2';
import { Box } from '@mui/material';
import { DataGrid, GridToolbar } from '@mui/x-data-grid';
import EventHeader from './EventHeader';
import ChartsPanel from './ChartsPanel';

const EventSection = ({ event, eventRows, eventColumns, showCharts = true }) => {
  const [tab, setTab] = React.useState('teams');

  return (
    <Grid2 key={event.number} sx={{ width: '100%', maxWidth: '100%', mb: 4 }}>
      <EventHeader
        event={event}
        tab={tab}
        onTabChange={(newTab) => setTab(newTab)}
        showCharts={showCharts}
      />

      <Box sx={{ width: '100%', maxWidth: '100%', overflowX: 'auto' }}>
        <Box sx={{ height: 500, minWidth: 600 }}>
          {tab === 'teams' || !showCharts ? (
            <DataGrid
              rows={eventRows}
              columns={eventColumns}
              slots={{ toolbar: GridToolbar }}
              slotProps={{ toolbar: { showQuickFilter: true, quickFilterProps: { debounceMs: 500 } } }}
            />
          ) : (
            <ChartsPanel event={event} />
          )}
        </Box>
      </Box>
    </Grid2>
  );
};

export default EventSection;
